import React, { FC } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { downloadDocument } from '../../store/merchnts/actions/application-details';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { ButtonLoading } from '../ButtonLoading';
import clsx from 'clsx';

interface Props {
  uploadedDocuments: any[];
  applicationId: string;
  isLoading?: boolean;
  showActions?: boolean;
}
export const DocumentsUploaderTable: FC<Props> = (props) => {
  const { uploadedDocuments, applicationId, isLoading, showActions } = props;
  const { merchantState: { isDocumentLoading }, dispatch } = useMerchants();
  const [documentId, setDocumentId] = React.useState<string | null>(null);

  const handleClick = async (documentId: string): Promise<void> => {
    setDocumentId(documentId);
    if (!isDocumentLoading) {
      await downloadDocument({ dispatch, applicationId, documentId });
    }
  };

  const rowAction = (rowData): JSX.Element => {
    return (
      <div
        className={clsx('text-muted text-center fw-bolder fs-7', !isDocumentLoading && 'cursor-pointer')}
        onClick={(): Promise<void> => handleClick(rowData?.original?.id)}
      >
        {
          isDocumentLoading && documentId === rowData?.original?.id
            ? <ButtonLoading />
            : 'Download'
        }
      </div>
    );
  };

  return (
    <Table
      name={TablesNames.documentsTableData}
      data={uploadedDocuments || []}
      isLoading={isLoading}
      enableHiding={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableRowActions={showActions}
      rowActions={rowAction}
      actionColumnsSize={10}
      positionActionsColumn='last'
    />
  );

};